import { __read, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import $tyW6A$react, { useRef, useState } from 'react';
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { useOverlayPosition } from 'react-aria';
import { CloseIcon } from '../../icons/CloseIcon.js';
import styles from './Tooltip.module.scss.js';

var Tooltip = function (_a) {
    var _b;
    var children = _a.children, content = _a.content, id = _a.id, _c = _a.offset, offset = _c === void 0 ? 13 : _c, placement = _a.placement, className = _a.className, style = _a.style, isOpen = _a.isOpen, _d = _a.controlledOutside, controlledOutside = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? 'text' : _e, onClose = _a.onClose;
    var triggerRef = useRef(null);
    var _f = __read(useState(null), 2), overlayEl = _f[0], setOverlayEl = _f[1];
    var _g = __read(useState(false), 2), isTouched = _g[0], setTouched = _g[1];
    var _h = __read(useState(false), 2), isHovered = _h[0], setHovered = _h[1];
    var isOpened = controlledOutside ? isOpen : isHovered || isTouched;
    var _j = useOverlayPosition({
        targetRef: triggerRef,
        overlayRef: { current: overlayEl },
        placement: placement,
        offset: offset,
        isOpen: isOpen,
    }), currentPlacement = _j.placement, arrowStyle = _j.arrowProps.style, overlayStyle = _j.overlayProps.style;
    var childrenProps = __assign(__assign(__assign({}, children.props), { 'aria-describedby': isOpened ? id : null, ref: triggerRef }), (controlledOutside
        ? {}
        : {
            onMouseOver: function () { return setHovered(true); },
            onMouseLeave: function () { return setHovered(false); },
            onTouchStart: function () { return setTouched(true); },
            onTouchEnd: function () { return setTouched(false); },
        }));
    return (jsxs(Fragment, { children: [$tyW6A$react.cloneElement(children, childrenProps), typeof window !== 'undefined' &&
                createPortal(jsx(CSSTransition, __assign({ in: isOpened, timeout: 300, classNames: {
                        enter: styles.tooltipEnter,
                        enterActive: styles.tooltipEnterActive,
                        exit: styles.tooltipExit,
                        exitActive: styles.tooltipExitActive,
                    }, unmountOnExit: true, nodeRef: { current: overlayEl } }, { children: jsxs("div", __assign({ ref: setOverlayEl, role: "tooltip", className: clsx(styles.tooltip, (_b = {}, _b[styles.tooltipText] = variant === 'text', _b), className), style: __assign(__assign({}, overlayStyle), style) }, { children: [content, onClose && (jsx("button", __assign({ className: styles.closeButton, onClick: onClose }, { children: jsx(CloseIcon, { variant: "small" }) }))), jsx("div", __assign({ className: clsx(styles.arrowContainer), "data-placement": currentPlacement, style: arrowStyle }, { children: jsx("div", { className: styles.arrow }) }))] })) })), document.querySelector('#portals'))] }));
};

export { Tooltip };
